import { render } from "./SearchTypeAhead.vue?vue&type=template&id=350cb6bf&scoped=true"
import script from "./SearchTypeAhead.vue?vue&type=script&lang=js"
export * from "./SearchTypeAhead.vue?vue&type=script&lang=js"

import "./SearchTypeAhead.vue?vue&type=style&index=0&id=350cb6bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350cb6bf"]])

export default __exports__